import { TeamTable } from './team-table';

export { TeamTable };
